import { useFormik } from "formik"
import { DynamicInput } from "./dynamicInput"
import { useLocation, useNavigate } from "react-router-dom";
import { BackPage } from "./backPage";
import { useState } from "react";
import { toast } from "sonner";
import getRespostas from "@/utils/getRespostas";
import { novaSolicitacao, getPassword } from "@/http/novaSolicitacao";
import { getSolicitacao } from "@/http/getSolicitacao";
import { useLocalStorage } from "@uidotdev/usehooks";

export function toastSenha(senha) {
  toast.custom((id) => (
    <div className="w-[350px] sm:w-[420px] bg-white border border-green-300 shadow-xl rounded-xl p-5 flex flex-col gap-3">

      <p className="text-green-600 font-bold text-lg">
        Senha encontrada!
      </p>

      <div className="bg-gray-100 border rounded-lg p-3 flex items-center justify-between gap-2">
        <span className="font-mono text-base select-all break-all">
          {senha}
        </span>

        <button
          onClick={() => {
            navigator.clipboard.writeText(senha);
            toast.success("Copiado!");
          }}
          className="text-sm bg-green-500 text-white px-3 py-1 rounded-md hover:bg-green-600"
        >
          Copiar
        </button>
      </div>

      <button
        onClick={() => toast.dismiss(id)}
        className="text-sm text-gray-500 hover:underline"
      >
        Fechar
      </button>
    </div>
  ));
}

export function ViewForm({ components, initialValues, backPage, recuperarSenha = false }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [unidade] = useLocalStorage("sessionUnidade", null);
  const [unidadeNome] = useLocalStorage("sessionUnidadeNome", null);

  const formik = useFormik({
    initialValues,
    onSubmit: async (values) => {
      try {
        setLoading(true);

        const cpf = values.cpf;
        const infoSolicitacao = location.pathname.split("/");
        const servico = infoSolicitacao[3];
        const setor = infoSolicitacao[2];

        const solicitacao = getRespostas(initialValues, values).filter(item => !item.label.startsWith("arquivo_"));

        const formData = new FormData();
        formData.append("unidade", unidade);
        if (unidadeNome) formData.append("unidade_origem", unidadeNome);
        formData.append("servico", servico);
        formData.append("setor", setor);
        formData.append("cpf", cpf);
        formData.append("solicitacao", JSON.stringify(solicitacao));

        Object.entries(values).forEach(([key, value]) => {
          if (key.startsWith("arquivo_") && value instanceof File) {
            formData.append(key, value);
          }
        });

        if(recuperarSenha === true ) {
          setLoading(false);

        const resultado = await getPassword(cpf, values.data_nascimento, unidade);

          toastSenha(resultado.senha);
          navigate(`/setor/recuperar_senha`)}

        else {
          const solicitacoesExistentes = await getSolicitacao({ cpf });
          const duplicada = solicitacoesExistentes?.find(
            (s) => s.setor === setor && s.servico === servico && !s.finalizado
          );

          if (duplicada) {
            setLoading(false);
            toast.warning(
              "Você já possui uma solicitação deste tipo em andamento. Aguarde a conclusão do atendimento dentro do prazo informado antes de realizar uma nova solicitação.",
              { duration: 8000 }
            );
            return;
          }

        const data = await novaSolicitacao(formData);
        setLoading(false);
        toast.success("Solicitação enviada com sucesso!");
        window.sessionStorage.clear();
        navigate(`/solicitacoes/${data.solicitacao}`)}
        

      } catch (error) {
        setLoading(false);
        console.log(error);
        toast.error(`Erro ao enviar solicitação: ${JSON.stringify(error.response?.data?.message || error.message || "Erro desconhecido")}`);
      }
    },
  });




  return (
    <form onSubmit={formik.handleSubmit} className="flex flex-col gap-2 px-2 mt-6 pb-8">
      {components.map((item, idx) => (
        <DynamicInput
          key={idx}
          type={item.type}
          label={item.label}
          id={item.id}
          component={item.component}
          formik={formik}
          helpText={item.helpText}
          loading={loading}
          required={item.required !== "opcional"}
        />
      ))}
      <BackPage href={backPage} />
    </form>
  )
}